export default __webpack_public_path__ + "static/media/Img020.7ef68b3e.jpg";